import { Component, OnInit, Input } from "@angular/core";
import { catchError, retry } from "rxjs/operators";
import { Router } from "@angular/router";
import { RestService } from "../rest.service";

@Component({
  selector: "app-activity-m-series",
  templateUrl: "./activity-m-series.component.html",
  styleUrls: ["./activity-m-series.component.css"],
})
export class ActivityMSeriesComponent implements OnInit {
  isSuccess: boolean = false;
  isFailure: boolean = false;
  isLoading: boolean = false;
  successMessage: any = "";
  failureMessage: any = "";
  envList: any = "";
  seriesID: any = "";
  seriesfromDate: any = "";
  seriestoDate: any = "";

  pageSize: any = 0;
  boxSize: any = 0;
  minValue: any = 0;
  maxValue: any = 0;
  prevValue: any = 0;

  data: any = [];
  filterArray: any = [];
  searchArray: any = [];
  actualArray: any = [];
  seriesFilterArray: any = [];
  seriesAcutalArray: any = [];
  seriesDataArray: any = [];
  isSeriesDetailPageShown: boolean = false;
  isPaginationClicked: boolean = false;
  isSeriesSorted: boolean = false;
  isDescriptionSorted: boolean = false;
  isStartTimeSorted: boolean = false;
  isFrequencySorted: boolean = false;
  isOccurrencesSorted: boolean = false;
  isLabelSorted: boolean = false;
  isSeriesStartTimeSorted: any = false;
  isSeriesEndTimeSorted: boolean = false;
  isSeriesDateFilterShown: boolean = false;
  isSeriesActivityIDSorted: boolean = false;
  isSeriesStatusSorted: boolean = false;
  isseriesError: boolean = false;
  isSeriesFilterClicked: boolean = false;

  paginationNumber: any;
  totalJobsCount: number = 0;
  paginationLength: number = 0;
  paginationContainer: any = [];
  activepage: any = 1;

  envID: any = "";
  sysID: any = "";
  SID: any = "";
  rowID: any = "";
  infoMessage: any = "";

  isConfirmDeleteOcc: boolean = false;
  isInfoModelShown: boolean = false;
  isConfirmDeleteSeries: boolean = false;

  isEdited: boolean = false;
  isEditOccShown: boolean = false;
  isReviewDateShown: boolean = false;
  isReviewTimeShown: boolean = false;
  editMachineId: any = "";
  isRecurringSelected: boolean = false;
  startDate: any = "";
  tphours: any = "00";
  tpminutes: any = "00";
  tptype: any = "AM";
  estEditHoursSelection: any = 0;
  estEditMinuteSelection: any = 0;
  disableIncreaseHrs: boolean = false;
  disableDecreaseHrs: boolean = false;
  disableIncreaseMins: boolean = false;
  disableDecreaseMins: boolean = false;
  estHours: any;
  estMintues: any;
  estEditHours: any;
  estEditMintues: any;
  machineId: any = "";
  isMachineIdInvalid: boolean = false;
  isSmartMatchChecked: boolean = false;

  botID: any = "";
  occID: any = "";
  mSingleOccId = "";
  mseriesid = "";
  headerobj: any = "";
  tableobj: any = [];
  occurance: any = [];
  machineobj: any = [];
  editedStartDateArray: any = [];
  MSingleArray: any = [];
  MSingleRes: any = [];
  jobRecurringRes: any = [];
  mtnRecurringRes: any = [];
  occurrenceResult: any = "";
  saveFrequency: any = "";
  masterEnvId: any = "";

  isEditMtnOccShown: boolean = false;
  isEditJobSeriesShown: boolean = false;
  isSeriesClicked: boolean = false;
  isEditMtnSeriesShown: boolean = false;

  @Input() environmentID: string;
  @Input() systemID: string;

  constructor(private _restService: RestService, private router: Router) {}

  ngOnInit() {
    (this.envID = this.environmentID),
      (this.sysID = this.systemID),
      (this.isLoading = true),
      this._restService
        .environmentList()
        .pipe(
          catchError((e) => {
            (this.isLoading = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            return e;
          })
        )
        .subscribe(
          (d: any) => (
            (this.envList = d.EnvList),
            this.envList.filter((m: any) =>
              parseInt(m.id) === parseInt(this.envID)
                ? (this.masterEnvId = m.MasterEnvId)
                : ""
            ),
            this.callbackSeriesOccurance(),
            (this.isLoading = false)
          )
        );

    this.estHours = Array(25)
      .fill(0)
      .map((x, i) => i);
    this.estMintues = Array(60)
      .fill(0)
      .map((x, i) => i);

    this.estEditHours = Array(25)
      .fill(0)
      .map((x, i) => i);
    this.estEditMintues = Array(60)
      .fill(0)
      .map((x, i) => i);
  }

  callbackSeriesOccurance = () => {
    this._restService
      .getMaintenceSeries(this.envID, this.sysID, this.masterEnvId)
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          ((this.filterArray = []),
          (this.actualArray = f.finalMaintenaceOcuurancesArr),
          (this.data = f.finalMaintenaceOcuurancesArr)),
          (this.totalJobsCount =
            parseFloat(f.finalMaintenaceOcuurancesArr.length) / 10),
          (this.paginationLength =
            this.totalJobsCount % 1 === 0
              ? Math.round(this.totalJobsCount)
              : Math.round(this.totalJobsCount) + 1),
          this.loopingPagination(f.finalMaintenaceOcuurancesArr.length),
          this.actualArray.map(
            (f: any) => (f.start = new Date(f.startDate).toString())
          ),
          this.actualArray.map(
            (f: any) => (
              (f.searchSeriesId = ("SR-" + f.seriesId).toString()),
              (f.frequency =
                f.repeatType === 1
                  ? "Daily"
                  : f.repeatType === 2
                  ? "Weekly"
                  : f.repeatType === 3
                  ? "Monthly"
                  : f.repeatType === 4
                  ? "Yearly"
                  : "")
            )
          ),
          this.actualArray.map((f: any, index: any) =>
            index + 1 <= 10 ? this.filterArray.push(f) : ""
          ),
          console.log("getMaintenceSeries ---->>>>", this.actualArray)
        )
      );
  };

  deleteSeries(sid: any, start: any) {
    if (new Date(start) >= new Date()) {
      this.isConfirmDeleteSeries = true;
      this.SID = sid;
    } else {
      this.isInfoModelShown = true;
      this.infoMessage = "You can't delete the past series";
    }
  }

  ConfirmDeleteSeriesEvent() {
    this.isConfirmDeleteSeries = false;
    this.isLoading = true;
    this.filterArray = [];

    this._restService
      .delMaintenanceSeries(this.envID, this.sysID, this.SID, this.masterEnvId)
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          this.callbackSeriesOccurance(),
          (this.isSuccess = true),
          (this.successMessage = f.response),
          (this.isLoading = false)
        )
      );
  }

  ConfirmCancelSeriesEvent() {
    this.isConfirmDeleteSeries = false;
  }

  deleteOccurrence(rid: any, start: any) {
    if (new Date(start) >= new Date()) {
      this.rowID = rid;
      this.isConfirmDeleteOcc = true;
    } else {
      this.isInfoModelShown = true;
      this.infoMessage = "You can't delete the past occurrence";
    }
  }

  ConfirmDeleteOccEvent() {
    this.isConfirmDeleteOcc = false;
    this.isLoading = true;
    this._restService
      .delMaintenanceOccurance(
        this.envID,
        this.sysID,
        this.rowID,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          this.callbackOccurrence(),
          (this.isSuccess = true),
          (this.successMessage = f.StatusInfo),
          (this.isLoading = false)
        )
      );
  }

  ConfirmCancelOccEvent() {
    this.isConfirmDeleteOcc = false;
  }

  cancelInfoMessage() {
    this.isInfoModelShown = false;
    this.infoMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.infoMessage = ""),
        this.router.navigate([""]))
      : (this.infoMessage = "");
  }

  selectEnvironment(e: any) {
    this.envID = e.target.value;

    this.envList.filter((m: any) =>
      parseInt(m.id) === parseInt(this.envID)
        ? (this.masterEnvId = m.MasterEnvId)
        : ""
    );

    (this.isLoading = true),
      this._restService
        .getMaintenceSeries(this.envID, this.sysID, this.masterEnvId)
        .pipe(
          catchError((e) => {
            (this.isLoading = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            ((this.filterArray = []),
            (this.actualArray = f.finalMaintenaceOcuurancesArr),
            (this.data = f.finalMaintenaceOcuurancesArr)),
            (this.totalJobsCount =
              parseFloat(f.finalMaintenaceOcuurancesArr.length) / 10),
            (this.paginationLength =
              this.totalJobsCount % 1 === 0
                ? Math.round(this.totalJobsCount)
                : Math.round(this.totalJobsCount) + 1),
            this.loopingPagination(f.finalMaintenaceOcuurancesArr.length),
            this.actualArray.map(
              (f: any) => (f.start = new Date(f.startDate).toString())
            ),
            this.actualArray.map(
              (f: any) => (
                (f.searchSeriesId = ("SR-" + f.seriesId).toString()),
                (f.frequency =
                  f.repeatType === 1
                    ? "Daily"
                    : f.repeatType === 2
                    ? "Weekly"
                    : f.repeatType === 3
                    ? "Monthly"
                    : f.repeatType === 4
                    ? "Yearly"
                    : "")
              )
            ),
            this.actualArray.map((f: any, index: any) =>
              index + 1 <= 10 ? this.filterArray.push(f) : ""
            ),
            (this.isLoading = false),
            console.log("getMaintenceSeries ---->>>>", this.actualArray)
          )
        );
  }

  loopingPagination(l: any) {
    this.minValue = 1;
    this.maxValue = l > 10 ? 10 : l;
    this.pageSize = l;
    this.prevValue = 0;
    console.log("pageSize", this.pageSize);
  }

  nextpage(c: any, type: any) {
    let pageSize = this.pageSize;
    this.minValue = c + 1;
    this.maxValue = c + 10 >= pageSize ? pageSize : c + 10;
    this.prevValue = c;

    console.log(this.minValue + "---" + this.maxValue + "---" + this.pageSize);

    type === "normal"
      ? ((this.filterArray = []),
        this.actualArray.map((f: any, index: any) =>
          index + 1 >= this.minValue && index + 1 <= this.maxValue
            ? this.filterArray.push(f)
            : ""
        ))
      : type === "series"
      ? ((this.seriesFilterArray = []),
        this.seriesAcutalArray.map((f: any, index: any) =>
          index + 1 >= this.minValue && index + 1 <= this.maxValue
            ? this.seriesFilterArray.push(f)
            : ""
        ))
      : "";
  }

  prevpage(p: any, type: any) {
    this.minValue = p - 10 + 1;
    this.maxValue = p;
    this.prevValue = p - 10;

    console.log(this.minValue + "---" + this.maxValue + "---" + this.prevValue);

    type === "normal"
      ? ((this.filterArray = []),
        this.actualArray.map((f: any, index: any) =>
          index + 1 >= this.minValue && index + 1 <= this.maxValue
            ? this.filterArray.push(f)
            : ""
        ))
      : type === "series"
      ? ((this.seriesFilterArray = []),
        this.seriesAcutalArray.map((f: any, index: any) =>
          index + 1 >= this.minValue && index + 1 <= this.maxValue
            ? this.seriesFilterArray.push(f)
            : ""
        ))
      : "";
  }

  series() {
    let sortedList: any = [];
    this.filterArray = [];
    if (this.isSeriesSorted === false) {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return a.seriesId - b.seriesId;
      });
      this.isSeriesSorted = true;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        ),
        (this.activepage = 1);
    } else {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return b.seriesId - a.seriesId;
      });
      this.isSeriesSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        ),
        (this.activepage = 1);
    }
  }

  labelSort() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isLabelSorted === false) {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return a.activity_label.localeCompare(b.activity_label);
      });
      this.isLabelSorted = true;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        ),
        (this.activepage = 1);
    } else {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return b.activity_label.localeCompare(a.activity_label);
      });
      this.isLabelSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        ),
        (this.activepage = 1);
    }
  }

  description() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isDescriptionSorted === false) {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return a.maintenanceDesc.localeCompare(b.maintenanceDesc);
      });
      this.isDescriptionSorted = true;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        ),
        (this.activepage = 1);
    } else {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return b.maintenanceDesc.localeCompare(a.maintenanceDesc);
      });
      this.isDescriptionSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        ),
        (this.activepage = 1);
    }
  }

  frequency() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isFrequencySorted === false) {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return a.frequency.localeCompare(b.frequency);
      });
      this.isFrequencySorted = true;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        ),
        (this.activepage = 1);
    } else {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return b.frequency.localeCompare(a.frequency);
      });
      this.isFrequencySorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        ),
        (this.activepage = 1);
    }
  }

  starttime() {
    let sortedList: any = [];
    this.filterArray = [];
    if (this.isStartTimeSorted === false) {
      sortedList = this.actualArray.sort(function compare(a: any, b: any) {
        a = new Date(a.startDate);
        b = new Date(b.startDate);
        return a - b;
      });
      this.isStartTimeSorted = true;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        );
    } else {
      sortedList = this.actualArray.sort(function compare(a: any, b: any) {
        a = new Date(a.startDate);
        b = new Date(b.startDate);
        return b - a;
      });
      this.isStartTimeSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        );
    }
  }

  sortingOccurrences() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isOccurrencesSorted === false) {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return a.totalOccurance - b.totalOccurance;
      });
      this.isOccurrencesSorted = true;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        );
      //this.filterArray = sortedList;
    } else {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return b.totalOccurance - a.totalOccurance;
      });
      this.isOccurrencesSorted = false;
      //this.filterArray = sortedList;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        );
    }
  }

  searchKeyword(e: any) {
    if (e.target.value === "") {
      (this.filterArray = []),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        );
    } else {
      let v = e.target.value.toLowerCase();
      this.searchArray = [];
      this.filterArray = [];

      this.actualArray.map((f: any) =>
        f.searchSeriesId.toLowerCase().includes(v) ||
        f.activity_label.toLowerCase().includes(v) ||
        f.maintenanceDesc.toLowerCase().includes(v) ||
        f.start.toLowerCase().includes(v) ||
        f.totalOccurance.toString().includes(v)
          ? this.searchArray.push(f)
          : ""
      );

      (this.totalJobsCount = parseFloat(this.actualArray.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.searchArray.length),
        this.searchArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        ),
        //this.filterArray = this.searchArray;
        console.log("filterArray", this.filterArray);
    }
  }

  searchSeries(e: any) {
    if (e.target.value === "") {
      (this.seriesFilterArray = []),
        (this.totalJobsCount = parseFloat(this.seriesAcutalArray.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.seriesAcutalArray.length),
        this.seriesAcutalArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.seriesFilterArray.push(f) : ""
        );
    } else {
      let v = e.target.value.toLowerCase();
      let temp: any = [];
      this.seriesFilterArray = [];
      this.searchArray = [];

      this.seriesAcutalArray.map((f: any) =>
        f.start.toLowerCase().includes(v) ||
        f.rowid.toString().includes(v) ||
        f.statusType.toLowerCase().includes(v) ||
        f.end.toLowerCase().includes(v)
          ? temp.push(f)
          : ""
      );

      (this.totalJobsCount =
        this.seriesAcutalArray.length > 10
          ? parseFloat(this.seriesAcutalArray.length) / 10
          : 1),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(temp.length),
        temp.map((f: any, index: any) =>
          index + 1 <= 10 ? this.seriesFilterArray.push(f) : ""
        );

      this.activepage = 1;
    }
    (this.seriesfromDate = ""), (this.seriestoDate = "");
  }

  seriesStartTime() {
    let sortedList: any = [];
    this.seriesFilterArray = [];
    if (this.isSeriesStartTimeSorted === false) {
      sortedList = this.seriesAcutalArray.sort(function compare(
        a: any,
        b: any
      ) {
        a = new Date(a.startDate);
        b = new Date(b.startDate);
        return a - b;
      });
      this.isSeriesStartTimeSorted = true;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.seriesAcutalArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.seriesFilterArray.push(f) : ""
        ),
        (this.activepage = 1);
    } else {
      sortedList = this.seriesAcutalArray.sort(function compare(
        a: any,
        b: any
      ) {
        a = new Date(a.startDate);
        b = new Date(b.startDate);
        return b - a;
      });
      this.isSeriesStartTimeSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.seriesAcutalArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.seriesFilterArray.push(f) : ""
        ),
        (this.activepage = 1);
    }
  }

  seriesEndTime() {
    let sortedList: any = [];
    this.seriesFilterArray = [];
    if (this.isSeriesEndTimeSorted === false) {
      sortedList = this.seriesAcutalArray.sort(function compare(
        a: any,
        b: any
      ) {
        a = new Date(a.startDate);
        b = new Date(b.startDate);
        return a - b;
      });
      this.isSeriesEndTimeSorted = true;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.seriesAcutalArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.seriesFilterArray.push(f) : ""
        ),
        (this.activepage = 1);
    } else {
      sortedList = this.seriesAcutalArray.sort(function compare(
        a: any,
        b: any
      ) {
        a = new Date(a.startDate);
        b = new Date(b.startDate);
        return b - a;
      });
      this.isSeriesEndTimeSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.seriesAcutalArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.seriesFilterArray.push(f) : ""
        ),
        (this.activepage = 1);
    }
  }

  seriesStatus() {
    let sortedList: any = [];
    this.seriesFilterArray = [];

    if (this.isSeriesStatusSorted === false) {
      sortedList = this.seriesAcutalArray.sort(function (a: any, b: any) {
        return a.statusType.localeCompare(b.statusType);
      });
      this.isSeriesStatusSorted = true;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.seriesAcutalArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.seriesFilterArray.push(f) : ""
        ),
        (this.activepage = 1);
    } else {
      sortedList = this.seriesAcutalArray.sort(function (a: any, b: any) {
        return b.statusType.localeCompare(a.statusType);
      });
      this.isSeriesStatusSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.seriesAcutalArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.seriesFilterArray.push(f) : ""
        ),
        (this.activepage = 1);
    }
  }

  seriesActivityID() {
    let sortedList: any = [];
    this.seriesFilterArray = [];

    if (this.isSeriesActivityIDSorted === false) {
      sortedList = this.seriesAcutalArray.sort(function (a: any, b: any) {
        return a.rowid - b.rowid;
      });
      this.isSeriesActivityIDSorted = true;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.seriesAcutalArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.seriesFilterArray.push(f) : ""
        ),
        (this.activepage = 1);
    } else {
      sortedList = this.seriesAcutalArray.sort(function (a: any, b: any) {
        return b.rowid - a.rowid;
      });
      this.isSeriesActivityIDSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.seriesAcutalArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.seriesFilterArray.push(f) : ""
        ),
        (this.activepage = 1);
    }
  }

  viewSeriesEvent(sid: any) {
    this.isSeriesDetailPageShown = true;
    this.seriesID = sid;
    this.isLoading = true;
    this.callbackOccurrence();
    this.isLoading = false;
  }

  callbackOccurrence = () => {
    this._restService
      .getMaintenceSeriesOccurance(
        this.envID,
        this.sysID,
        this.seriesID,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (d: any) => (
          (this.seriesFilterArray = []),
          (this.seriesAcutalArray = d.systemSeries),
          (this.seriesDataArray = d.systemSeries),
          console.log("Series -->", d.systemSeries),
          (this.totalJobsCount =
            parseFloat(this.seriesAcutalArray.length) / 10),
          (this.paginationLength =
            this.totalJobsCount % 1 === 0
              ? Math.round(this.totalJobsCount)
              : Math.round(this.totalJobsCount) + 1),
          this.loopingPagination(this.seriesAcutalArray.length),
          this.seriesAcutalArray.map(
            (f: any) => (
              (f.start = new Date(f.startDate).toString()),
              (f.end = new Date(f.endDate).toString()),
              (f.statusType =
                f.status === 2
                  ? "Flagged"
                  : f.status === 1 && new Date(f.endDate) < new Date()
                  ? "completed"
                  : f.status === 1 && new Date(f.endDate) > new Date()
                  ? "Schedule"
                  : "")
            )
          ),
          this.seriesAcutalArray.map((f: any, index: any) =>
            index + 1 <= 10 ? this.seriesFilterArray.push(f) : ""
          ),
          (this.activepage = 1),
          console.log("m -getMaintenceSeriesOccurance ", this.seriesAcutalArray)
        )
      );
  };

  seriescurrentPage(c: any) {
    this.seriesFilterArray = [];
    this.isPaginationClicked = true;
    let cp = c + 1;
    this.paginationNumber = cp;
    let maxValue = cp * 10;
    let minValue = maxValue - 10 + 1;
    console.log(minValue + "---" + maxValue);

    this.seriesAcutalArray.map((f: any, index: any) =>
      index + 1 >= minValue && index + 1 <= maxValue
        ? this.seriesFilterArray.push(f)
        : ""
    ),
      (this.activepage = cp);
  }

  backtoSeriesList() {
    this.isSeriesDetailPageShown = false;
    this.filterArray = [];
    (this.isLoading = true),
      this._restService
        .environmentList()
        .pipe(
          catchError((e) => {
            (this.isLoading = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            return e;
          })
        )
        .subscribe(
          (d: any) => (
            (this.envList = d.EnvList),
            this._restService
              .getMaintenceSeries(this.envID, this.sysID, this.masterEnvId)
              .pipe(
                catchError((e) => {
                  (this.isLoading = false),
                    (this.isFailure = true),
                    (this.failureMessage = e.error.StatusInfo);
                  return e;
                })
              )
              .subscribe(
                (f: any) => (
                  ((this.filterArray = []),
                  (this.actualArray = f.finalMaintenaceOcuurancesArr),
                  (this.data = f.finalMaintenaceOcuurancesArr)),
                  (this.totalJobsCount =
                    parseFloat(f.finalMaintenaceOcuurancesArr.length) / 10),
                  (this.paginationLength =
                    this.totalJobsCount % 1 === 0
                      ? Math.round(this.totalJobsCount)
                      : Math.round(this.totalJobsCount) + 1),
                  this.loopingPagination(f.finalMaintenaceOcuurancesArr.length),
                  this.actualArray.map(
                    (f: any) =>
                      (f.start = new Date(f.startDate).toLocaleString())
                  ),
                  this.actualArray.map(
                    (f: any) => (
                      (f.searchSeriesId = ("SR-" + f.seriesId).toString()),
                      (f.frequency =
                        f.repeatType === 1
                          ? "Daily"
                          : f.repeatType === 2
                          ? "Weekly"
                          : f.repeatType === 3
                          ? "Monthly"
                          : f.repeatType === 4
                          ? "Yearly"
                          : "")
                    )
                  ),
                  this.actualArray.map((f: any, index: any) =>
                    index + 1 <= 10 ? this.filterArray.push(f) : ""
                  ),
                  (this.isLoading = false)
                )
              )
          )
        );
  }

  seriesdatefilterEvent() {
    this.isSeriesDateFilterShown = true;
  }

  seriescloseDateFilter() {
    this.isSeriesDateFilterShown = false;
  }

  seriesapplyDateFilter() {
    var temp: any = [];

    console.log(this.seriesfromDate + "-----" + this.seriestoDate);

    if (this.seriesfromDate !== "" && this.seriestoDate !== "") {
      this.isseriesError = false;

      var startDate = new Date(this.seriesfromDate).toLocaleDateString();
      var endDate = new Date(this.seriestoDate).toLocaleDateString();

      this.isSeriesDateFilterShown = false;
      this.isSeriesFilterClicked = true;
      this.isLoading = true;

      this._restService
        .getMaintenceSeriesOccurance(
          this.envID,
          this.sysID,
          this.seriesID,
          this.masterEnvId
        )
        .pipe(
          catchError((e) => {
            (this.isLoading = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            return e;
          })
        )
        .subscribe(
          (d: any) => (
            (this.isLoading = false),
            (this.seriesFilterArray = []),
            (this.seriesDataArray = d.systemSeries),
            console.log("Series -->", d.systemSeries),
            this.seriesAcutalArray.map(
              (f: any) => (
                (f.sStartDate = new Date(f.startDate).toLocaleDateString()),
                (f.sEndDate = new Date(f.endDate).toLocaleDateString()),
                (f.startDate = new Date(f.startDate).toLocaleString()),
                (f.endDate = new Date(f.endDate).toLocaleString())
              )
            ),
            this.seriesAcutalArray.map(
              (f: any) => (
                (f.startDate = new Date(f.startDate).toLocaleString()),
                (f.endDate = new Date(f.endDate).toLocaleString()),
                (f.start = new Date(f.startDate).toString()),
                (f.end = new Date(f.endDate).toString()),
                (f.statusType =
                  f.status === 2
                    ? "Flagged"
                    : f.status === 1 && new Date(f.endDate) < new Date()
                    ? "completed"
                    : f.status === 1 && new Date(f.endDate) > new Date()
                    ? "Schedule"
                    : "")
              )
            ),
            this.seriesAcutalArray.filter((f: any) =>
              new Date(f.sStartDate).getTime() >=
                new Date(startDate).getTime() &&
              new Date(f.sEndDate).getTime() <= new Date(endDate).getTime()
                ? temp.push(f)
                : ""
            ),
            (this.totalJobsCount =
              this.seriesAcutalArray.length > 10
                ? parseFloat(this.seriesAcutalArray.length) / 10
                : 1),
            (this.paginationLength =
              this.totalJobsCount % 1 === 0
                ? Math.round(this.totalJobsCount)
                : Math.round(this.totalJobsCount) + 1),
            this.loopingPagination(temp.length),
            temp.map((f: any, index: any) =>
              index + 1 <= 10 ? this.seriesFilterArray.push(f) : ""
            ),
            (this.activepage = 1),
            console.log("seriesFilterArray -->", this.seriesFilterArray)
          )
        );
    } else {
      this.isseriesError = true;
    }
  }

  selectSeriesEnvironment(e: any) {
    this.envID = e.target.value;

    this.envList.filter((m: any) =>
      parseInt(m.id) === parseInt(this.envID)
        ? (this.masterEnvId = m.MasterEnvId)
        : ""
    );

    this.isLoading = true;
    this._restService
      .getMaintenceSeriesOccurance(
        this.envID,
        this.sysID,
        this.seriesID,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (d: any) => (
          (this.isLoading = false),
          (this.seriesFilterArray = []),
          (this.seriesAcutalArray = d.systemSeries),
          (this.seriesDataArray = d.systemSeries),
          console.log("Series -->", d.systemSeries),
          (this.totalJobsCount =
            parseFloat(this.seriesAcutalArray.length) / 10),
          (this.paginationLength =
            this.totalJobsCount % 1 === 0
              ? Math.round(this.totalJobsCount)
              : Math.round(this.totalJobsCount) + 1),
          this.loopingPagination(this.seriesAcutalArray.length),
          this.seriesAcutalArray.map(
            (f: any) => (
              (f.start = new Date(f.startDate).toString()),
              (f.end = new Date(f.endDate).toString()),
              (f.statusType =
                f.status === 2
                  ? "Flagged"
                  : f.status === 1 && new Date(f.endDate) < new Date()
                  ? "completed"
                  : f.status === 1 && new Date(f.endDate) > new Date()
                  ? "Schedule"
                  : "")
            )
          ),
          this.seriesAcutalArray.map((f: any, index: any) =>
            index + 1 <= 10 ? this.seriesFilterArray.push(f) : ""
          ),
          (this.activepage = 1),
          (this.seriesfromDate = ""),
          (this.seriestoDate = ""),
          console.log("m -getMaintenceSeriesOccurance ", this.seriesAcutalArray)
        )
      );
  }

  clearapplyDateFilter() {
    this.isSeriesFilterClicked = false;
    this.seriesfromDate = "";
    this.seriestoDate = "";
    this.seriesrefreshEvent();
  }

  seriesrefreshEvent() {
    this.isLoading = true;
    this._restService
      .getMaintenceSeriesOccurance(
        this.envID,
        this.sysID,
        this.seriesID,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (d: any) => (
          (this.isLoading = false),
          (this.seriesFilterArray = []),
          (this.seriesAcutalArray = d.systemSeries),
          (this.seriesDataArray = d.systemSeries),
          console.log("Series -->", d.systemSeries),
          (this.totalJobsCount =
            parseFloat(this.seriesAcutalArray.length) / 10),
          (this.paginationLength =
            this.totalJobsCount % 1 === 0
              ? Math.round(this.totalJobsCount)
              : Math.round(this.totalJobsCount) + 1),
          this.loopingPagination(this.seriesAcutalArray.length),
          this.seriesAcutalArray.map(
            (f: any) => (
              (f.start = new Date(f.startDate).toString()),
              (f.end = new Date(f.endDate).toString()),
              (f.statusType =
                f.status === 2
                  ? "Flagged"
                  : f.status === 1 && new Date(f.endDate) < new Date()
                  ? "completed"
                  : f.status === 1 && new Date(f.endDate) > new Date()
                  ? "Schedule"
                  : "")
            )
          ),
          this.seriesAcutalArray.map(
            (f: any) => (
              (f.startDate = new Date(f.startDate).toLocaleString()),
              (f.endDate = new Date(f.endDate).toLocaleString())
            )
          ),
          this.seriesAcutalArray.map((f: any, index: any) =>
            index + 1 <= 10 ? this.seriesFilterArray.push(f) : ""
          ),
          (this.activepage = 1),
          (this.seriesfromDate = ""),
          (this.seriestoDate = "")
        )
      );
  }

  addingHoursMinutes(d: any) {
    d.startHour = new Date(d.startDate).getHours();
    d.startMinutes = new Date(d.startDate).getMinutes();
    d.endHours = new Date(d.endDate).getHours();
    d.endMinutes = new Date(d.endDate).getMinutes();
    d.position =
      parseInt(d.startHour) * 70 + (parseInt(d.startMinutes) / 60) * 70;
    d.length = parseInt(d.endHours) * 70 + (parseInt(d.endMinutes) / 60) * 70;
  }

  closeJobModelShown() {
    this.isEditOccShown = false;
    this.isEditMtnOccShown = false;
    this.isEditJobSeriesShown = false;
    this.isEditMtnSeriesShown = false;
  }

  chartExpandEvent(id: any) {
    this.isReviewDateShown = false;
    this.isReviewTimeShown = false;
    var col = this.tableobj;

    col.filter(
      (f: any) => (
        (f.isfold = false),
        parseInt(f.rowid) === parseInt(id)
          ? f.isfold === true
            ? ((f.isfold = false), console.log("in", f.isfold))
            : ((f.isfold = true), console.log("out", f.isfold))
          : ""
      )
    );

    console.log("col", col);
    this.tableobj = col;

    var t = this.tableobj;
    t.filter((f: any) =>
      f.rowid === id
        ? ((this.editMachineId = this.isRecurringSelected
            ? f.MachineId
            : f.machineId),
          (this.startDate = f.NewStart),
          localStorage.setItem(
            "cancelDate",
            (
              new Date(f.NewStart).getDate() +
              "/" +
              (new Date(f.NewStart).getMonth() + 1) +
              "/" +
              new Date(f.NewStart).getFullYear()
            ).toString()
          ),
          localStorage.setItem(
            "singleDate",
            (
              new Date(f.NewStart).getDate() +
              "/" +
              (new Date(f.NewStart).getMonth() + 1) +
              "/" +
              new Date(f.NewStart).getFullYear()
            ).toString()
          ))
        : ""
    );

    t.filter((f: any) =>
      f.rowid === id
        ? (new Date(f.NewStart).getHours() > 12
            ? new Date(f.NewStart).getHours() - 12 < 10
              ? (this.tphours = "0" + (new Date(f.NewStart).getHours() - 12))
              : (this.tphours = new Date(f.NewStart).getHours() - 12)
            : new Date(f.NewStart).getHours() < 10
            ? (this.tphours = "0" + new Date(f.NewStart).getHours())
            : new Date(f.NewStart).getHours(),
          (this.tpminutes =
            new Date(f.NewStart).getMinutes().toString().length <= 1
              ? "0" + new Date(f.NewStart).getMinutes()
              : new Date(f.NewStart).getMinutes()),
          (this.tptype = new Date(f.NewStart).getHours() > 12 ? "PM" : "AM"))
        : ""
    );

    this.tableobj.filter((f: any) =>
      f.OccuranceId === this.occID
        ? (this.headerobj.durations = f.jobDuration)
        : ""
    );

    console.log("this.headerobj", this.headerobj);

    if (this.isSeriesClicked) {
      (this.estEditHoursSelection = parseInt(
        localStorage.getItem("seriesHours")
      )),
        (this.estEditMinuteSelection = parseInt(
          localStorage.getItem("seriesMins")
        ));
    } else {
      let duration: any;
      this.headerobj.hasOwnProperty("jobDuration")
        ? (duration = this.headerobj.jobDuration.split(":"))
        : this.headerobj.hasOwnProperty("duration")
        ? (duration = this.headerobj.duration.split(":"))
        : "";

      this.estEditHoursSelection = parseInt(duration[0]);
      this.estEditMinuteSelection = parseInt(duration[1]);
      console.log("duration", duration);
    }
  }

  resetMtnSchedule(id: any, occid: any) {
    this.isEdited = false;
    this.chartExpandForMtnEvent(id, occid);
  }

  chartExpandForMtnEvent(id: any, occid: any) {
    this.isReviewDateShown = false;
    this.isReviewTimeShown = false;
    this.occID = occid;
    var col = this.tableobj;

    col.filter(
      (f: any) => (
        (f.isfold = false),
        parseInt(f.rowid) === parseInt(id)
          ? f.isfold === true
            ? ((f.isfold = false), console.log("in", f.isfold))
            : ((f.isfold = true), console.log("out", f.isfold))
          : ""
      )
    );

    console.log("col", col);
    this.tableobj = col;

    var t = this.tableobj;
    t.filter((f: any) =>
      f.rowid === id
        ? ((this.editMachineId = this.isRecurringSelected
            ? f.MachineId
            : f.machineId),
          (this.startDate = f.NewStart),
          localStorage.setItem(
            "cancelDate",
            (
              new Date(f.NewStart).getDate() +
              "/" +
              (new Date(f.NewStart).getMonth() + 1) +
              "/" +
              new Date(f.NewStart).getFullYear()
            ).toString()
          ),
          localStorage.setItem(
            "singleDate",
            (
              new Date(f.NewStart).getDate() +
              "/" +
              (new Date(f.NewStart).getMonth() + 1) +
              "/" +
              new Date(f.NewStart).getFullYear()
            ).toString()
          ))
        : ""
    );

    t.filter((f: any) =>
      f.rowid === id
        ? (new Date(f.NewStart).getHours() > 12
            ? new Date(f.NewStart).getHours() - 12 < 10
              ? (this.tphours = "0" + (new Date(f.NewStart).getHours() - 12))
              : (this.tphours = new Date(f.NewStart).getHours() - 12)
            : new Date(f.NewStart).getHours() < 10
            ? (this.tphours = "0" + new Date(f.NewStart).getHours())
            : new Date(f.NewStart).getHours(),
          (this.tpminutes =
            new Date(f.NewStart).getMinutes().toString().length <= 1
              ? "0" + new Date(f.NewStart).getMinutes()
              : new Date(f.NewStart).getMinutes()),
          (this.tptype = new Date(f.NewStart).getHours() > 12 ? "PM" : "AM"))
        : ""
    );

    console.log("duration for Mtn", this.occID);

    let duration: any;

    this.tableobj.filter((f: any) =>
      f.moccuranceid === this.occID ? (duration = f.duration.split(":")) : ""
    );

    this.estEditHoursSelection = parseInt(duration[0]);
    this.estEditMinuteSelection = parseInt(duration[1]);

    console.log("duration for Mtn", duration);
  }

  reviewDateEvent() {
    this.isReviewDateShown = !this.isReviewDateShown;
    this.isReviewTimeShown = false;
  }

  closeDate() {
    var d = localStorage.getItem("cancelDate");
    this.startDate = d.split("/").reverse().join("-");
    localStorage.setItem("singleDate", d);
    this.isReviewDateShown = false;
  }

  applyDate() {
    var d = localStorage.getItem("singleDate");
    this.startDate = d.split("/").reverse().join("-");
    localStorage.setItem("singleDate", d);
    localStorage.setItem("cancelDate", d);
    this.isReviewDateShown = false;
  }

  reviewTimeEvent(id: any) {
    this.isReviewTimeShown = !this.isReviewTimeShown;
    this.isReviewDateShown = false;
  }

  closeTime() {
    this.isReviewTimeShown = false;
  }

  increaseHrs() {
    var hrs = parseInt(this.tphours) + 1;
    this.disableDecreaseHrs = false;
    if (hrs >= 12) {
      this.tphours = 12;
      this.disableIncreaseHrs = true;
    } else {
      this.tphours = hrs >= 10 ? hrs : "0" + hrs;
      this.disableIncreaseHrs = false;
    }
  }

  decreaseHrs() {
    var hrs = parseInt(this.tphours) - 1;
    this.disableIncreaseHrs = false;
    if (hrs <= 0) {
      this.tphours = "00";
      this.disableDecreaseHrs = true;
    } else {
      this.tphours = hrs >= 10 ? hrs : "0" + hrs;
      this.disableDecreaseHrs = false;
    }
  }

  increaseMins() {
    var mins = parseInt(this.tpminutes) + 1;
    this.disableDecreaseMins = false;
    if (mins > 59) {
      this.disableIncreaseMins = true;
    } else {
      this.disableIncreaseMins = false;
      this.tpminutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  decreaseMins() {
    var mins = parseInt(this.tpminutes);
    this.disableIncreaseMins = false;
    if (mins === 0) {
      this.disableDecreaseMins = true;
      this.tpminutes = "00";
    } else {
      mins = parseInt(this.tpminutes) - 1;
      this.disableDecreaseMins = false;
      this.tpminutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  changetimeformat() {
    var f = this.tptype;
    f === "AM" ? (this.tptype = "PM") : (this.tptype = "AM");
  }

  estEditHoursEvent(e: any) {
    var hrs = parseInt(e.target.value);
    if (hrs === 24) {
      this.estEditMinuteSelection = 0;
      this.estEditMintues = Array(1)
        .fill(0)
        .map((x, i) => i);
    } else {
      this.estEditMintues = Array(60)
        .fill(0)
        .map((x, i) => i);
    }
    localStorage.setItem("seriesHours", this.estEditHoursSelection.toString());
    localStorage.setItem("seriesMins", this.estEditMinuteSelection.toString());
  }

  estEditMinutesEvent(e: any) {
    var mins = parseInt(e.target.value);
    var hrs = this.estEditHoursSelection;
    if (hrs === 0) {
      this.isFailure = true;
      this.failureMessage = "Should be greater than 0";
    }
    localStorage.setItem("seriesHours", this.estEditHoursSelection.toString());
    localStorage.setItem("seriesMins", this.estEditMinuteSelection.toString());
  }

  onChangeMachine(e: any) {
    this.machineId = e.target.value;
    this.editMachineId = e.target.value;
    this.isMachineIdInvalid = false;
    this.isSmartMatchChecked = false;
  }

  cancelSchedule(id: any) {
    var t = this.tableobj;
    t.filter((f: any) =>
      f.rowid === id
        ? f.isfold === true
          ? (f.isfold = false)
          : (f.isfold = true)
        : ""
    );
  }

  resetSchedule(id: any) {
    this.isEdited = false;
    this.chartExpandEvent(id);
  }

  editMaintenanceSeries(sid: any) {
    this.isEditMtnSeriesShown = true;
    this.isLoading = true;
    this.mseriesid = sid;
    this._restService
      .getMaintenanceSeries(this.envID, sid, this.masterEnvId)
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.response
              ? e.error.response
              : e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log(f),
          (this.mtnRecurringRes = f),
          (this.tableobj = []),
          (this.headerobj = f.response.headerObj),
          (this.tableobj = f.response.OccuranceTable),
          this.tableobj.filter((m: any) => (m.isfold = false)),
          this.tableobj.filter((m: any, index: any) => (m.rowid = index + 1)),
          this.tableobj.filter(
            (m: any, index: any) => (
              (m.endTime = new Date(m.NewEnd).getTime()),
              (m.startTime = new Date(m.NewStart).getTime())
            )
          ),
          this.tableobj.filter(
            (m: any, index: any) => (
              (m.seconds = (m.endTime - m.startTime) / 1000),
              (m.duration =
                Math.floor(m.seconds / 3600) +
                ":" +
                (Math.floor(m.seconds / 60) % 60))
            )
          ),
          console.log("table 1", this.tableobj),
          this.tableobj.filter((m: any) =>
            m.hasOwnProperty("MaintenaceAccess")
              ? m.MaintenaceAccess.filter(
                  (a: any) => (
                    a.hasOwnProperty("Mlist")
                      ? a.Mlist.filter((dt: any) => this.addingHoursMinutes(dt))
                      : "",
                    a.hasOwnProperty("children")
                      ? a.children.filter(
                          (b: any) => (
                            b.hasOwnProperty("Mlist")
                              ? b.Mlist.filter((dt: any) =>
                                  this.addingHoursMinutes(dt)
                                )
                              : "",
                            b.hasOwnProperty("children")
                              ? b.children.filter(
                                  (c: any) => (
                                    c.hasOwnProperty("Mlist")
                                      ? c.Mlist.filter((dt: any) =>
                                          this.addingHoursMinutes(dt)
                                        )
                                      : "",
                                    c.hasOwnProperty("children")
                                      ? c.children.filter(
                                          (d: any) => (
                                            d.hasOwnProperty("Mlist")
                                              ? d.Mlist.filter((dt: any) =>
                                                  this.addingHoursMinutes(dt)
                                                )
                                              : "",
                                            d.hasOwnProperty("children")
                                              ? d.children.filter(
                                                  (f: any) => (
                                                    f.hasOwnProperty("Mlist")
                                                      ? f.Mlist.filter(
                                                          (dt: any) =>
                                                            this.addingHoursMinutes(
                                                              dt
                                                            )
                                                        )
                                                      : "",
                                                    f.hasOwnProperty("children")
                                                      ? f.children.filter(
                                                          (g: any) => (
                                                            g.hasOwnProperty(
                                                              "Mlist"
                                                            )
                                                              ? g.Mlist.filter(
                                                                  (dt: any) =>
                                                                    this.addingHoursMinutes(
                                                                      dt
                                                                    )
                                                                )
                                                              : "",
                                                            g.hasOwnProperty(
                                                              "children"
                                                            )
                                                              ? g.children.filter(
                                                                  (h: any) => (
                                                                    h.hasOwnProperty(
                                                                      "Mlist"
                                                                    )
                                                                      ? h.Mlist.filter(
                                                                          (
                                                                            dt: any
                                                                          ) =>
                                                                            this.addingHoursMinutes(
                                                                              dt
                                                                            )
                                                                        )
                                                                      : "",
                                                                    h.hasOwnProperty(
                                                                      "children"
                                                                    )
                                                                      ? h.children.filter(
                                                                          (
                                                                            j: any
                                                                          ) => (
                                                                            j.hasOwnProperty(
                                                                              "Mlist"
                                                                            )
                                                                              ? j.Mlist.filter(
                                                                                  (
                                                                                    dt: any
                                                                                  ) =>
                                                                                    this.addingHoursMinutes(
                                                                                      dt
                                                                                    )
                                                                                )
                                                                              : "",
                                                                            j.hasOwnProperty(
                                                                              "children"
                                                                            )
                                                                              ? j.children.filter(
                                                                                  (
                                                                                    k: any
                                                                                  ) => (
                                                                                    k.hasOwnProperty(
                                                                                      "Mlist"
                                                                                    )
                                                                                      ? k.Mlist.filter(
                                                                                          (
                                                                                            dt: any
                                                                                          ) =>
                                                                                            this.addingHoursMinutes(
                                                                                              dt
                                                                                            )
                                                                                        )
                                                                                      : "",
                                                                                    k.hasOwnProperty(
                                                                                      "children"
                                                                                    )
                                                                                      ? k.children.filter(
                                                                                          (
                                                                                            l: any
                                                                                          ) => (
                                                                                            l.hasOwnProperty(
                                                                                              "Mlist"
                                                                                            )
                                                                                              ? l.Mlist.filter(
                                                                                                  (
                                                                                                    dt: any
                                                                                                  ) =>
                                                                                                    this.addingHoursMinutes(
                                                                                                      dt
                                                                                                    )
                                                                                                )
                                                                                              : "",
                                                                                            l.hasOwnProperty(
                                                                                              "children"
                                                                                            )
                                                                                              ? l.children.filter(
                                                                                                  (
                                                                                                    m: any
                                                                                                  ) =>
                                                                                                    m.hasOwnProperty(
                                                                                                      "Mlist"
                                                                                                    )
                                                                                                      ? m.Mlist.filter(
                                                                                                          (
                                                                                                            dt: any
                                                                                                          ) =>
                                                                                                            this.addingHoursMinutes(
                                                                                                              dt
                                                                                                            )
                                                                                                        )
                                                                                                      : ""
                                                                                                )
                                                                                              : ""
                                                                                          )
                                                                                        )
                                                                                      : ""
                                                                                  )
                                                                                )
                                                                              : ""
                                                                          )
                                                                        )
                                                                      : ""
                                                                  )
                                                                )
                                                              : ""
                                                          )
                                                        )
                                                      : ""
                                                  )
                                                )
                                              : ""
                                          )
                                        )
                                      : ""
                                  )
                                )
                              : ""
                          )
                        )
                      : ""
                  )
                )
              : ""
          ),
          console.log("table final ---->>>>>", this.tableobj),
          (this.isLoading = false)
        )
      );
  }

  updateMaintenanceSeries(occid: any) {
    this.occID = occid;
    this.isLoading = true;
    var shour =
      this.tptype === "AM" ? this.tphours : parseInt(this.tphours) + 12;

    var range = {
      startTime: {
        hours: shour.toString(),
        minutes: this.tpminutes.toString(),
      },
      end: {
        endTime: {
          hours: "00",
          minutes: "00",
          totalDuration: "00",
        },
        duration: {
          hours: this.estEditHoursSelection.toString(),
          minutes: this.estEditMinuteSelection.toString(),
        },
        isEndTime: false,
      },
    };

    var sd = new Date(this.startDate).toLocaleDateString("fr-CA");
    var s = sd.split("/").reverse().join("-");
    var sdt = [];
    sdt.push(s);
    console.log("dates--->" + JSON.stringify(sdt));


    this._restService
      .createMaintenanceSchedule(
        this.headerobj.activityLabel,
        this.envID,
        this.tableobj[0].MaintenaceAccess,
        this.headerobj.description,
        sdt,
        range,
        true,
        this.occID,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.response
              ? e.error.response
              : e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("1", f),
          console.log("2", this.mtnRecurringRes),
          console.log("3", this.occID),
          console.log("4", occid),
          //response.headerObj
          this.mtnRecurringRes.response.OccuranceTable.filter(
            (m: any, i: any) =>
              parseInt(m.moccuranceid) === parseInt(this.occID)
                ? Object.assign(m, f.maintenanceRes.OccuranceTable[0])
                : ""
          ),
          this.mtnRecurringRes.response.OccuranceTable.filter((m: any) =>
            parseInt(m.moccuranceid) === parseInt(this.occID)
              ? (m.isEdited = true)
              : ""
          ),
          (this.tableobj = []),
          (this.headerobj = this.mtnRecurringRes.response.headerObj),
          (this.tableobj = this.mtnRecurringRes.response.OccuranceTable),
          this.tableobj.filter((m: any) => (m.isfold = false)),
          this.tableobj.filter((m: any, index: any) => (m.rowid = index + 1)),
          this.tableobj.filter(
            (m: any, index: any) => (
              (m.endTime = new Date(m.NewEnd).getTime()),
              (m.startTime = new Date(m.NewStart).getTime())
            )
          ),
          this.tableobj.filter(
            (m: any, index: any) => (
              (m.seconds = (m.endTime - m.startTime) / 1000),
              (m.duration =
                Math.floor(m.seconds / 3600) +
                ":" +
                (Math.floor(m.seconds / 60) % 60))
            )
          ),
          console.log("table 1", this.tableobj),
          console.log("table final ---->>>>>", this.tableobj),
          this.tableobj.filter((m: any) =>
            m.hasOwnProperty("MaintenaceAccess")
              ? m.MaintenaceAccess.filter(
                  (a: any) => (
                    a.hasOwnProperty("Mlist")
                      ? a.Mlist.filter((dt: any) => this.addingHoursMinutes(dt))
                      : "",
                    a.hasOwnProperty("children")
                      ? a.children.filter(
                          (b: any) => (
                            b.hasOwnProperty("Mlist")
                              ? b.Mlist.filter((dt: any) =>
                                  this.addingHoursMinutes(dt)
                                )
                              : "",
                            b.hasOwnProperty("children")
                              ? b.children.filter(
                                  (c: any) => (
                                    c.hasOwnProperty("Mlist")
                                      ? c.Mlist.filter((dt: any) =>
                                          this.addingHoursMinutes(dt)
                                        )
                                      : "",
                                    c.hasOwnProperty("children")
                                      ? c.children.filter(
                                          (d: any) => (
                                            d.hasOwnProperty("Mlist")
                                              ? d.Mlist.filter((dt: any) =>
                                                  this.addingHoursMinutes(dt)
                                                )
                                              : "",
                                            d.hasOwnProperty("children")
                                              ? d.children.filter(
                                                  (f: any) => (
                                                    f.hasOwnProperty("Mlist")
                                                      ? f.Mlist.filter(
                                                          (dt: any) =>
                                                            this.addingHoursMinutes(
                                                              dt
                                                            )
                                                        )
                                                      : "",
                                                    f.hasOwnProperty("children")
                                                      ? f.children.filter(
                                                          (g: any) => (
                                                            g.hasOwnProperty(
                                                              "Mlist"
                                                            )
                                                              ? g.Mlist.filter(
                                                                  (dt: any) =>
                                                                    this.addingHoursMinutes(
                                                                      dt
                                                                    )
                                                                )
                                                              : "",
                                                            g.hasOwnProperty(
                                                              "children"
                                                            )
                                                              ? g.children.filter(
                                                                  (h: any) => (
                                                                    h.hasOwnProperty(
                                                                      "Mlist"
                                                                    )
                                                                      ? h.Mlist.filter(
                                                                          (
                                                                            dt: any
                                                                          ) =>
                                                                            this.addingHoursMinutes(
                                                                              dt
                                                                            )
                                                                        )
                                                                      : "",
                                                                    h.hasOwnProperty(
                                                                      "children"
                                                                    )
                                                                      ? h.children.filter(
                                                                          (
                                                                            j: any
                                                                          ) => (
                                                                            j.hasOwnProperty(
                                                                              "Mlist"
                                                                            )
                                                                              ? j.Mlist.filter(
                                                                                  (
                                                                                    dt: any
                                                                                  ) =>
                                                                                    this.addingHoursMinutes(
                                                                                      dt
                                                                                    )
                                                                                )
                                                                              : "",
                                                                            j.hasOwnProperty(
                                                                              "children"
                                                                            )
                                                                              ? j.children.filter(
                                                                                  (
                                                                                    k: any
                                                                                  ) => (
                                                                                    k.hasOwnProperty(
                                                                                      "Mlist"
                                                                                    )
                                                                                      ? k.Mlist.filter(
                                                                                          (
                                                                                            dt: any
                                                                                          ) =>
                                                                                            this.addingHoursMinutes(
                                                                                              dt
                                                                                            )
                                                                                        )
                                                                                      : "",
                                                                                    k.hasOwnProperty(
                                                                                      "children"
                                                                                    )
                                                                                      ? k.children.filter(
                                                                                          (
                                                                                            l: any
                                                                                          ) => (
                                                                                            l.hasOwnProperty(
                                                                                              "Mlist"
                                                                                            )
                                                                                              ? l.Mlist.filter(
                                                                                                  (
                                                                                                    dt: any
                                                                                                  ) =>
                                                                                                    this.addingHoursMinutes(
                                                                                                      dt
                                                                                                    )
                                                                                                )
                                                                                              : "",
                                                                                            l.hasOwnProperty(
                                                                                              "children"
                                                                                            )
                                                                                              ? l.children.filter(
                                                                                                  (
                                                                                                    m: any
                                                                                                  ) =>
                                                                                                    m.hasOwnProperty(
                                                                                                      "Mlist"
                                                                                                    )
                                                                                                      ? m.Mlist.filter(
                                                                                                          (
                                                                                                            dt: any
                                                                                                          ) =>
                                                                                                            this.addingHoursMinutes(
                                                                                                              dt
                                                                                                            )
                                                                                                        )
                                                                                                      : ""
                                                                                                )
                                                                                              : ""
                                                                                          )
                                                                                        )
                                                                                      : ""
                                                                                  )
                                                                                )
                                                                              : ""
                                                                          )
                                                                        )
                                                                      : ""
                                                                  )
                                                                )
                                                              : ""
                                                          )
                                                        )
                                                      : ""
                                                  )
                                                )
                                              : ""
                                          )
                                        )
                                      : ""
                                  )
                                )
                              : ""
                          )
                        )
                      : ""
                  )
                )
              : ""
          ),
          (this.isLoading = false)
        )
      );
  }

  editMaintenance(mid: any) {
    this.isEditMtnOccShown = true;
    this.isLoading = true;
    this.mSingleOccId = mid;
    this._restService
      .getMaintenanceOccurance(this.envID, mid, this.masterEnvId)
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("MSingle", f),
          (this.MSingleArray = f.maintenanceRes),
          (this.tableobj = []),
          (this.headerobj = f.maintenanceRes.headerObj),
          (this.tableobj = f.maintenanceRes.OccuranceTable),
          this.tableobj.filter((m: any) => (m.isfold = false)),
          this.tableobj.filter((m: any, index: any) => (m.rowid = index + 1)),
          console.log("table 1", this.tableobj),
          this.tableobj.filter((m: any) =>
            m.hasOwnProperty("MaintenaceAccess")
              ? m.MaintenaceAccess.filter(
                  (a: any) => (
                    a.hasOwnProperty("Mlist")
                      ? a.Mlist.filter((dt: any) => this.addingHoursMinutes(dt))
                      : "",
                    a.hasOwnProperty("children")
                      ? a.children.filter(
                          (b: any) => (
                            b.hasOwnProperty("Mlist")
                              ? b.Mlist.filter((dt: any) =>
                                  this.addingHoursMinutes(dt)
                                )
                              : "",
                            b.hasOwnProperty("children")
                              ? b.children.filter(
                                  (c: any) => (
                                    c.hasOwnProperty("Mlist")
                                      ? c.Mlist.filter((dt: any) =>
                                          this.addingHoursMinutes(dt)
                                        )
                                      : "",
                                    c.hasOwnProperty("children")
                                      ? c.children.filter(
                                          (d: any) => (
                                            d.hasOwnProperty("Mlist")
                                              ? d.Mlist.filter((dt: any) =>
                                                  this.addingHoursMinutes(dt)
                                                )
                                              : "",
                                            d.hasOwnProperty("children")
                                              ? d.children.filter(
                                                  (f: any) => (
                                                    f.hasOwnProperty("Mlist")
                                                      ? f.Mlist.filter(
                                                          (dt: any) =>
                                                            this.addingHoursMinutes(
                                                              dt
                                                            )
                                                        )
                                                      : "",
                                                    f.hasOwnProperty("children")
                                                      ? f.children.filter(
                                                          (g: any) => (
                                                            g.hasOwnProperty(
                                                              "Mlist"
                                                            )
                                                              ? g.Mlist.filter(
                                                                  (dt: any) =>
                                                                    this.addingHoursMinutes(
                                                                      dt
                                                                    )
                                                                )
                                                              : "",
                                                            g.hasOwnProperty(
                                                              "children"
                                                            )
                                                              ? g.children.filter(
                                                                  (h: any) => (
                                                                    h.hasOwnProperty(
                                                                      "Mlist"
                                                                    )
                                                                      ? h.Mlist.filter(
                                                                          (
                                                                            dt: any
                                                                          ) =>
                                                                            this.addingHoursMinutes(
                                                                              dt
                                                                            )
                                                                        )
                                                                      : "",
                                                                    h.hasOwnProperty(
                                                                      "children"
                                                                    )
                                                                      ? h.children.filter(
                                                                          (
                                                                            j: any
                                                                          ) => (
                                                                            j.hasOwnProperty(
                                                                              "Mlist"
                                                                            )
                                                                              ? j.Mlist.filter(
                                                                                  (
                                                                                    dt: any
                                                                                  ) =>
                                                                                    this.addingHoursMinutes(
                                                                                      dt
                                                                                    )
                                                                                )
                                                                              : "",
                                                                            j.hasOwnProperty(
                                                                              "children"
                                                                            )
                                                                              ? j.children.filter(
                                                                                  (
                                                                                    k: any
                                                                                  ) => (
                                                                                    k.hasOwnProperty(
                                                                                      "Mlist"
                                                                                    )
                                                                                      ? k.Mlist.filter(
                                                                                          (
                                                                                            dt: any
                                                                                          ) =>
                                                                                            this.addingHoursMinutes(
                                                                                              dt
                                                                                            )
                                                                                        )
                                                                                      : "",
                                                                                    k.hasOwnProperty(
                                                                                      "children"
                                                                                    )
                                                                                      ? k.children.filter(
                                                                                          (
                                                                                            l: any
                                                                                          ) => (
                                                                                            l.hasOwnProperty(
                                                                                              "Mlist"
                                                                                            )
                                                                                              ? l.Mlist.filter(
                                                                                                  (
                                                                                                    dt: any
                                                                                                  ) =>
                                                                                                    this.addingHoursMinutes(
                                                                                                      dt
                                                                                                    )
                                                                                                )
                                                                                              : "",
                                                                                            l.hasOwnProperty(
                                                                                              "children"
                                                                                            )
                                                                                              ? l.children.filter(
                                                                                                  (
                                                                                                    m: any
                                                                                                  ) =>
                                                                                                    m.hasOwnProperty(
                                                                                                      "Mlist"
                                                                                                    )
                                                                                                      ? m.Mlist.filter(
                                                                                                          (
                                                                                                            dt: any
                                                                                                          ) =>
                                                                                                            this.addingHoursMinutes(
                                                                                                              dt
                                                                                                            )
                                                                                                        )
                                                                                                      : ""
                                                                                                )
                                                                                              : ""
                                                                                          )
                                                                                        )
                                                                                      : ""
                                                                                  )
                                                                                )
                                                                              : ""
                                                                          )
                                                                        )
                                                                      : ""
                                                                  )
                                                                )
                                                              : ""
                                                          )
                                                        )
                                                      : ""
                                                  )
                                                )
                                              : ""
                                          )
                                        )
                                      : ""
                                  )
                                )
                              : ""
                          )
                        )
                      : ""
                  )
                )
              : ""
          ),
          console.log("table final ---->>>>>", this.tableobj),
          (this.isLoading = false)
        )
      );
  }

  updateMaintenanceSingle(mid: any) {
    console.log("Point here---->", mid);
    let header = this.MSingleArray.headerObj;
    let msystemAccess = this.MSingleArray.OccuranceTable;
    console.log("Points header---->", header);
    console.log("Points msystemAccess---->", msystemAccess);

    let list = msystemAccess[0].MaintenaceAccess;
    let systemAccessList = [];

    list.map(
      (a: any) => (
        systemAccessList.push(a),
        a.hasOwnProperty("children")
          ? a.children.map(
              (b: any) => (
                systemAccessList.push(b),
                b.hasOwnProperty("children")
                  ? b.children.map(
                      (c: any) => (
                        systemAccessList.push(c),
                        c.hasOwnProperty("children")
                          ? c.children.map(
                              (d: any) => (
                                systemAccessList.push(d),
                                d.hasOwnProperty("children")
                                  ? d.children.map(
                                      (f: any) => (
                                        systemAccessList.push(f),
                                        f.hasOwnProperty("children")
                                          ? f.children.map(
                                              (g: any) => (
                                                systemAccessList.push(g),
                                                g.hasOwnProperty("children")
                                                  ? g.children.map(
                                                      (h: any) => (
                                                        systemAccessList.push(
                                                          h
                                                        ),
                                                        h.hasOwnProperty(
                                                          "children"
                                                        )
                                                          ? h.children.map(
                                                              (j: any) => (
                                                                systemAccessList.push(
                                                                  j
                                                                ),
                                                                j.hasOwnProperty(
                                                                  "children"
                                                                )
                                                                  ? j.children.map(
                                                                      (
                                                                        k: any
                                                                      ) => (
                                                                        systemAccessList.push(
                                                                          k
                                                                        ),
                                                                        k.hasOwnProperty(
                                                                          "children"
                                                                        )
                                                                          ? k.children.map(
                                                                              (
                                                                                l: any
                                                                              ) =>
                                                                                systemAccessList.push(
                                                                                  l
                                                                                )
                                                                            )
                                                                          : ""
                                                                      )
                                                                    )
                                                                  : ""
                                                              )
                                                            )
                                                          : ""
                                                      )
                                                    )
                                                  : ""
                                              )
                                            )
                                          : ""
                                      )
                                    )
                                  : ""
                              )
                            )
                          : ""
                      )
                    )
                  : ""
              )
            )
          : ""
      )
    );

    systemAccessList.map(
      (a: any) => (
        a.hasOwnProperty("children") ? delete a.children : "",
        a.hasOwnProperty("envList") ? delete a.envList : ""
      )
    );

    console.log("Point System", systemAccessList);

    var shour =
      this.tptype === "AM" ? this.tphours : parseInt(this.tphours) + 12;

    var range = {
      startTime: {
        hours: shour.toString(),
        minutes: this.tpminutes.toString(),
      },
      end: {
        endTime: {
          hours: "00",
          minutes: "00",
          totalDuration: "00",
        },
        duration: {
          hours: this.estEditHoursSelection.toString(),
          minutes: this.estEditMinuteSelection.toString(),
        },
        isEndTime: false,
      },
    };

    var sd = new Date(this.startDate).toLocaleDateString("fr-CA");
    var s = sd.split("/").reverse().join("-");
    var sdt = [];
    sdt.push(s);
    console.log("dates--->" + JSON.stringify(sdt));


    this._restService
      .createMaintenanceSchedule(
        header.activityLabel,
        this.envID,
        systemAccessList,
        header.description,
        sdt,
        range,
        true,
        this.mSingleOccId,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.response
              ? e.error.response
              : e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log(f),
          (this.MSingleRes = f.maintenanceRes),
          (this.tableobj = []),
          (this.headerobj = f.maintenanceRes.headerObj),
          (this.tableobj = f.maintenanceRes.OccuranceTable),
          this.tableobj.filter((m: any) => (m.isfold = false)),
          this.tableobj.filter((m: any, index: any) => (m.rowid = index + 1)),
          console.log("table 1", this.tableobj),
          this.tableobj.filter((m: any) =>
            m.hasOwnProperty("MaintenaceAccess")
              ? m.MaintenaceAccess.filter(
                  (a: any) => (
                    a.hasOwnProperty("Mlist")
                      ? a.Mlist.filter((dt: any) => this.addingHoursMinutes(dt))
                      : "",
                    a.hasOwnProperty("children")
                      ? a.children.filter(
                          (b: any) => (
                            b.hasOwnProperty("Mlist")
                              ? b.Mlist.filter((dt: any) =>
                                  this.addingHoursMinutes(dt)
                                )
                              : "",
                            b.hasOwnProperty("children")
                              ? b.children.filter(
                                  (c: any) => (
                                    c.hasOwnProperty("Mlist")
                                      ? c.Mlist.filter((dt: any) =>
                                          this.addingHoursMinutes(dt)
                                        )
                                      : "",
                                    c.hasOwnProperty("children")
                                      ? c.children.filter(
                                          (d: any) => (
                                            d.hasOwnProperty("Mlist")
                                              ? d.Mlist.filter((dt: any) =>
                                                  this.addingHoursMinutes(dt)
                                                )
                                              : "",
                                            d.hasOwnProperty("children")
                                              ? d.children.filter(
                                                  (f: any) => (
                                                    f.hasOwnProperty("Mlist")
                                                      ? f.Mlist.filter(
                                                          (dt: any) =>
                                                            this.addingHoursMinutes(
                                                              dt
                                                            )
                                                        )
                                                      : "",
                                                    f.hasOwnProperty("children")
                                                      ? f.children.filter(
                                                          (g: any) => (
                                                            g.hasOwnProperty(
                                                              "Mlist"
                                                            )
                                                              ? g.Mlist.filter(
                                                                  (dt: any) =>
                                                                    this.addingHoursMinutes(
                                                                      dt
                                                                    )
                                                                )
                                                              : "",
                                                            g.hasOwnProperty(
                                                              "children"
                                                            )
                                                              ? g.children.filter(
                                                                  (h: any) => (
                                                                    h.hasOwnProperty(
                                                                      "Mlist"
                                                                    )
                                                                      ? h.Mlist.filter(
                                                                          (
                                                                            dt: any
                                                                          ) =>
                                                                            this.addingHoursMinutes(
                                                                              dt
                                                                            )
                                                                        )
                                                                      : "",
                                                                    h.hasOwnProperty(
                                                                      "children"
                                                                    )
                                                                      ? h.children.filter(
                                                                          (
                                                                            j: any
                                                                          ) => (
                                                                            j.hasOwnProperty(
                                                                              "Mlist"
                                                                            )
                                                                              ? j.Mlist.filter(
                                                                                  (
                                                                                    dt: any
                                                                                  ) =>
                                                                                    this.addingHoursMinutes(
                                                                                      dt
                                                                                    )
                                                                                )
                                                                              : "",
                                                                            j.hasOwnProperty(
                                                                              "children"
                                                                            )
                                                                              ? j.children.filter(
                                                                                  (
                                                                                    k: any
                                                                                  ) => (
                                                                                    k.hasOwnProperty(
                                                                                      "Mlist"
                                                                                    )
                                                                                      ? k.Mlist.filter(
                                                                                          (
                                                                                            dt: any
                                                                                          ) =>
                                                                                            this.addingHoursMinutes(
                                                                                              dt
                                                                                            )
                                                                                        )
                                                                                      : "",
                                                                                    k.hasOwnProperty(
                                                                                      "children"
                                                                                    )
                                                                                      ? k.children.filter(
                                                                                          (
                                                                                            l: any
                                                                                          ) => (
                                                                                            l.hasOwnProperty(
                                                                                              "Mlist"
                                                                                            )
                                                                                              ? l.Mlist.filter(
                                                                                                  (
                                                                                                    dt: any
                                                                                                  ) =>
                                                                                                    this.addingHoursMinutes(
                                                                                                      dt
                                                                                                    )
                                                                                                )
                                                                                              : "",
                                                                                            l.hasOwnProperty(
                                                                                              "children"
                                                                                            )
                                                                                              ? l.children.filter(
                                                                                                  (
                                                                                                    m: any
                                                                                                  ) =>
                                                                                                    m.hasOwnProperty(
                                                                                                      "Mlist"
                                                                                                    )
                                                                                                      ? m.Mlist.filter(
                                                                                                          (
                                                                                                            dt: any
                                                                                                          ) =>
                                                                                                            this.addingHoursMinutes(
                                                                                                              dt
                                                                                                            )
                                                                                                        )
                                                                                                      : ""
                                                                                                )
                                                                                              : ""
                                                                                          )
                                                                                        )
                                                                                      : ""
                                                                                  )
                                                                                )
                                                                              : ""
                                                                          )
                                                                        )
                                                                      : ""
                                                                  )
                                                                )
                                                              : ""
                                                          )
                                                        )
                                                      : ""
                                                  )
                                                )
                                              : ""
                                          )
                                        )
                                      : ""
                                  )
                                )
                              : ""
                          )
                        )
                      : ""
                  )
                )
              : ""
          ),
          //console.log("table final ---->>>>>", this.tableobj),
          (this.isLoading = false)
        )
      );
  }

  msingleSave() {
    this.isLoading = true;

    let header = this.MSingleRes.headerObj;
    let occuranceTable = this.MSingleRes.OccuranceTable;

    this._restService
      .editMOccurance(
        this.mSingleOccId,
        this.envID,
        header.activityLabel,
        header.description,
        occuranceTable[0].NewStart,
        occuranceTable[0].NewEnd,
        header.duration,
        occuranceTable[0].Status,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.response
              ? e.error.response
              : e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("msingleSave", f),
          (this.isEditMtnOccShown = false),
          this.callbackOccurrence(),
          (this.isSuccess = true),
          (this.successMessage = f.StatusInfo),
          (this.isLoading = false)
        )
      );
  }

  mseriesSave() {
    this.isLoading = true;

    this._restService
      .editRecMaintenance(
        this.envID,
        this.mseriesid,
        this.headerobj,
        this.tableobj,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("Save Rec Mtn", f),
          (this.isEditMtnSeriesShown = false),
          this.callbackSeriesOccurance(),
          (this.isSuccess = true),
          (this.successMessage = f.response),
          (this.isLoading = false)
        )
      );
  }

  confirmFailureMessage() {
    this.isFailure = false;
    this.failureMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.failureMessage = ""),
        this.router.navigate([""]))
      : (this.failureMessage = "");
  }

  confirmSuccessMessage() {
    this.isSuccess = false;
    this.successMessage = "";
  }
}
